import type {RouteObject} from 'react-router-dom';

export const routes = [
  {
    path: '*',
    async lazy() {
      const {NotFoundPage} = await import('./pages/NotFoundPage');
      return {element: <NotFoundPage />};
    },
  },
] as RouteObject[];
